<template>
  <div id="evaluate-question">
    <div class="bj" v-show="alertShow">
      <div class="box">
        <img src="../assets/gan.png" style="margin:50px 0 30px 0;width: 50px;"/><br />
        <span style="display: inline-block;width:66%;font-size:20px;font-weight:400;line-height:30px;margin-bottom: 56px;">您的设备已低于同行业比例 请检查题目！  </span><br />
        <img @click="alertShow=false" style="margin-top:36px;width:40px;" src="../assets/close.png"/>
      </div>
    </div>
    <evaluator-header class="mainHeader" @logout="logoutClick"></evaluator-header>
    <div class="">
      <div class="wrapper">
        <div class="title1">
          <span v-if="timuData.siteCategoryParentName"><span style="font-size:20px;">风险评测 - </span> {{timuData.siteCategoryParentName + ' - ' + timuData.siteCategoryName}}</span>
          <span v-else><span style="font-size:20px;">风险评测 - </span> {{timuData.siteCategoryName}}</span>
        </div>
        <div v-for="(item,i) in timuData.siteQuestionList" :key="i" :id="i">
          <!--  多选 -->
          <div class="timu" :class="{'weitian':item.weida&&isclick}" v-if="item.que_type==2">
            <div class="title">{{i+1}}. {{item.que_content}}<span class="beizhu"> ( 多选 )</span></div>
            <div v-for="(list,i) of item.siteQuestionAnswerList" :key="i">
              <el-checkbox @change="changes(item,list)" style="line-height:40px;" v-model="list.as">{{list.answer_content}}</el-checkbox>
            </div>
            <span v-if="item.weida&&isclick" class="weida"> 请完成答题</span>
          </div>
          <!-- 输入框题目 -->
          <div class="timu" :class="{'weitian':item.weida&&isclick}" v-else-if="item.que_type==5">
            <div class="title">{{i+1}}. {{item.que_content}}<span class="beizhu"> ( 输入框 )</span></div>
            <input @input="inputChange(item)" class="inputs" type="text" :maxlength="item.maxlength" :placeholder="item.placeholder" v-model="item.as"/>
            <span v-if="item.weida&&isclick" class="weida"> 请完成答题</span>
          </div>
          <!--  多选加输入框 -->
          <div class="timu" :class="{'weitian':item.weida&&isclick}" v-else-if="item.que_type==6">
            <div class="title">{{i+1}}. {{item.que_content}}<span class="beizhu"> ( 多选 )</span></div>
            <div v-for="(list,i) of item.siteQuestionAnswerList" :key="i">
              <el-checkbox @change="changes(item,list)" style="line-height:40px;" v-model="list.as">{{list.answer_content}}</el-checkbox>
              <div class="shurukuangBox"  v-show="list.as&&list.answer_content!='都没有'">
                <input class="inputs" @input="changes(item,list)" v-model="list.num" type="text" style="padding-left:20px;" :maxlength="item.maxlength" :placeholder="item.placeholder" oninput="if(value.length == 1){value=value.replace(/[^1-9]/g,'')}else{value=value.replace(/[^0-9]/g,'')}"/>
              </div>
            </div>
            <span v-if="item.weida&&isclick" class="weida"> 请完成答题</span>
          </div>
          <!-- 输入框加子题目 -->
          <div class="timu" :class="{'weitian':item.weida&&isclick}" v-else-if="item.que_type==7">
            <div class="title">{{i+1}}. {{item.que_content}}<span class="beizhu"> ( 输入框 )</span></div>
            <div>
              <input class="inputs" v-model="item.as" @input="inputChange(item)" type="text" :maxlength="item.maxlength" :placeholder="item.placeholder"/>
              <zitimu @datachange="datachange" :datas="item" :isclick="isclick" :weida="item.weida"></zitimu>
            </div>
            <span v-if="item.weida&&isclick" class="weida"> 请完成答题</span>
          </div>
          <!--  单选题加输入框 -->
          <div class="timu" :class="{'weitian':item.weida&&isclick}" v-else-if="item.que_type==8">
            <div class="title">{{i+1}}. {{item.que_content}}<span class="beizhu"> ( 单选 )</span></div>
            <div v-for="(list,index) of item.siteQuestionAnswerList" :key="index">
              <el-radio v-model="item.as" @change='changes(item)' style="line-height:40px;" :key="index" :label="list.answer_content"></el-radio>
              <div v-show="item.userQuestionAnswerList.answer=='有'&&list.answer_content!=='没有'" class="shurukuangBox" >
                <input v-model="item.num" @input='inputChange(item)' type="text" class="inputs" :maxlength="item.maxlength" :placeholder="item.placeholder" oninput="if(value.length == 1){value=value.replace(/[^1-9]/g,'')}else{value=value.replace(/[^0-9]/g,'')}" />
              </div>
            </div>
            <span v-if="item.weida&&isclick" class="weida"> 请完成答题</span>
          </div>
          <!--  单选加子题目  -->
          <div class="timu" :class="{'weitian':item.weida&&isclick}" v-else-if="item.que_type==9">
            <div class="title">{{i+1}}. {{item.que_content}}<span class="beizhu"> ( 单选 )</span></div>
            <div v-for="(list,index) of item.siteQuestionAnswerList" :key="index">
              <el-radio v-model="item.as" @change='changes(item)' style="line-height:40px;" :key="index" :label="list.answer_content"></el-radio>
              <div v-show="item.userQuestionAnswerList.answer=='有'&&list.answer_content!=='没有'" class="shurukuangBox" >
                <input v-model="item.num" type="text" class="inputs"  :maxlength="item.maxlength" :placeholder="item.placeholder" oninput="if(value.length == 1){value=value.replace(/[^1-9]/g,'')}else{value=value.replace(/[^0-9]/g,'')}" />
              </div>
            </div>
            <span v-if="item.weida&&isclick" class="weida"> 请完成答题</span>
          </div>
          <!-- 输入框答案加子题 -->
          <div class="timu" :class="{'weitian':item.weida&&isclick}" v-else-if="item.que_type==10">
            <div class="title">{{i+1}}. {{item.que_content}}<span class="beizhu"> ( 输入框 )</span></div>
            <div>
              <input class="inputs" v-model="item.as" @input='inputChange(item)' type="text" :maxlength="item.maxlength" :placeholder="item.placeholder" oninput="if(value.length == 1){value=value.replace(/[^1-9]/g,'')}else{value=value.replace(/[^0-9]/g,'')}"/>
              <zitimu @datachange="datachange" :datas="item" :isclick="isclick" :weida="item.weida"></zitimu>
            </div>
            <span v-if="item.weida&&isclick" class="weida"> 请完成答题</span>
          </div>
          <!--  多选加输入框答案加子题 -->
          <div class="timu" :class="{'weitian':item.weida&&isclick}" v-else-if="item.que_type==11">
            <div class="title">{{i+1}}. {{item.que_content}}<span class="beizhu"> ( 多选 )</span></div>
            <div v-for="(list,i) of item.siteQuestionAnswerList" :key="i">
              <el-checkbox @change="changes(item,list)" style="line-height:40px;" v-model="list.as">{{list.answer_content}}</el-checkbox>
              <div class="shurukuangBox" v-show="list.as&&list.answer_content!='都没有'">
                <input @input="changes(item,list)" class="inputs" v-model="list.num" type="text" style="padding-left:20px;" :maxlength="item.maxlength" :placeholder="item.placeholder"/>
                <!-- 这个题目的子项是放在list里的-->
                <zitimu @datachange="datachange" :datas="list" :isclick="isclick" :weida="item.weida"></zitimu>
              </div>
            </div>
            <span v-if="item.weida&&isclick" class="weida"> 请完成答题</span>
          </div>
        </div>
      </div>
    </div>
    <bottomButton v-show="!disabled" @click="submit" id="bottomButton" title="下一步" :state="1"></bottomButton>
    <bottomButton v-show="disabled" @click="submit1" id="bottomButton" title="下一步" :state="0"></bottomButton>
  </div>
</template>

<script>
import bottomButton from '../components/bottom-button'
import { Toast } from 'mint-ui'
import wxShare from '../wx/weixin.js'
import zitimu from './zitimu.vue'
import evaluatorHeader from '../view/evaluator-header'
import axios from 'axios'
export default {
  data () {
    return {
      disabled: true,
      timuData: {},
      alertShow: false,
      isclick: false
    }
  },
  components: {bottomButton, evaluatorHeader, zitimu},
  mounted () {
    var _this = this
    this.utils.isUserLogin(function (login) {
      if (login === 0) {
        Toast('您还未登录，请登录后再评测！')
        _this.$router.push({path: 'home'})
      }
    })
    this.gettimu()
  },
  methods: {
    logoutClick: function () { // 退出登录
      this.$router.push({path: 'home'})
    },
    inputChange (item, list) {
      if (item.que_type == 10 || item.que_type == 5 || item.que_type == 7) {
        if (/^[0-9]{1,6}$/.test(item.as)) {
          if (item.as && item.as.length == 1) {
            this.$set(item, 'as', item.as.replace(/[^1-9]/g, ''))
          } else {
            this.$set(item, 'as', item.as.replace(/[^0-9]/g, ''))
          }
        } else {
          this.$set(item, 'as', '')
        }
        item.as ? this.$set(item, 'userQuestionAnswerList', [{'answer': item.as}]) : this.$set(item, 'userQuestionAnswerList', [])
        if (item.que_type == 7) {
          item.subList.forEach((list, i) => {
            if (list.limit_compare == 1) {
              this.$set(list, 'show', item.as > list.limit_number)
            } else if (list.limit_compare == 2) {
              this.$set(list, 'show', item.as >= list.limit_number)
            } else if (list.limit_compare == 3) {
              this.$set(list, 'show', item.as < list.limit_number)
            } else if (list.limit_compare == 4) {
              this.$set(list, 'show', item.as <= list.limit_number)
            } else if (list.limit_compare == 5) {
              this.$set(list, 'show', item.as == list.limit_number)
            }
          })
        }
      } else if (item.que_type == 8) {
        console.log('que_type:', item.que_type)
        if (/^[0-9]{1,6}$/.test(item.num)) {
          if (item.num && item.num.length == 1) {
            this.$set(item, 'num', item.num.replace(/[^1-9]/g, ''))
          } else {
            this.$set(item, 'num', item.num.replace(/[^0-9]/g, ''))
          }
        } else {
          this.$set(item, 'num', '')
        }
        item.userQuestionAnswerList = {'answer': item.as, 'number': item.num}
      }
      this.yijireg()
    },
    // 用户填写资料给相应的组件赋值
    changes (item, list) {
      if (item.que_type == 2) {
        if (list.answer_content == '都没有' && list.as) {
          for (var i = 0; i < item.siteQuestionAnswerList.length - 1; i++) {
            this.$set(item.siteQuestionAnswerList[i], 'as', false)
          }
        } else if (list.as) {
          this.$set(item.siteQuestionAnswerList[item.siteQuestionAnswerList.length - 1], 'as', false)
        }
        this.$set(item, 'userQuestionAnswerList', [])
        item.siteQuestionAnswerList.forEach((ite, ind) => {
          ite.as ? item.userQuestionAnswerList.push({'answer': ite.answer_content}) : ''
        })
      } else if (item.que_type == 6) {
        if (/^[0-9]{1,6}$/.test(list.num)) {
          if (list.num && list.num.length == 1) {
            this.$set(list, 'num', list.num.replace(/[^1-9]/g, ''))
          } else {
            this.$set(list, 'num', list.num.replace(/[^0-9]/g, ''))
          }
        } else {
          this.$set(list, 'num', '')
        }
        if (list.answer_content == '都没有' && list.as) {
          for (var i = 0; i < item.siteQuestionAnswerList.length - 1; i++) {
            this.$set(item.siteQuestionAnswerList[i], 'as', false)
          }
          this.$set(item, 'userQuestionAnswerList', [{'answer': list.answer_content}])
        } else if (list.as) {
          this.$set(item, 'userQuestionAnswerList', [])
          item.siteQuestionAnswerList.forEach((ite, ind) => {
            ite.as ? item.userQuestionAnswerList.push({'answer': ite.answer_content, 'number': ite.num}) : ''
          })
          this.$set(item.siteQuestionAnswerList[item.siteQuestionAnswerList.length - 1], 'as', false)
        } else {
          this.$set(item, 'userQuestionAnswerList', [])
          item.siteQuestionAnswerList.forEach((ite, ind) => {
            ite.as ? item.userQuestionAnswerList.push({'answer': ite.answer_content, 'number': ite.num}) : ''
          })
        }
      } else if (item.que_type == 8) {
        item.userQuestionAnswerList = {'answer': item.as, 'number': item.num}
      } else if (item.que_type == 11) { // 多选加输入框答案加子题
        if (/^[0-9]{1,6}$/.test(list.num)) {
          if (list.num && list.num.length == 1) { this.$set(list, 'num', list.num.replace(/[^1-9]/g, '')) } else { this.$set(list, 'num', list.num.replace(/[^0-9]/g, '')) }
        } else {
          this.$set(list, 'num', '')
        }
        if (list.answer_content == '都没有' && list.as) {
          for (var i = 0; i < item.siteQuestionAnswerList.length - 1; i++) {
            this.$set(item.siteQuestionAnswerList[i], 'as', false)
          }
          this.$set(item, 'userQuestionAnswerList', [])
          item.userQuestionAnswerList.push({'answer': list.answer_content})
        } else if (list.as) {
          this.$set(item, 'userQuestionAnswerList', [])
          item.siteQuestionAnswerList.forEach((ite, ind) => {
            ite.as ? item.userQuestionAnswerList.push({'answer': ite.answer_content, 'number': ite.num}) : ''
          })
          this.$set(item.siteQuestionAnswerList[item.siteQuestionAnswerList.length - 1], 'as', false)
        } else {
          this.$set(item, 'userQuestionAnswerList', [])
          item.siteQuestionAnswerList.forEach((ite, ind) => {
            ite.as ? item.userQuestionAnswerList.push({'answer': ite.answer_content, 'number': ite.num}) : ''
          })
          list.subList.forEach((list1, j) => { // 把题目的答案清空
            this.$set(list1, 'userQuestionAnswerList', [])
            if (list1.que_type == 6) {
              list1.siteQuestionAnswerList.forEach((list2, k) => {
                this.$set(list2, 'as', false)
                this.$set(list2, 'num', '')
              })
            }
          })
        }
      }
      this.yijireg()
    },
    datachange (data, item, lists) {
      if (item.remote_verify == 1) { // 这道题的子题需要请求接口，做智能提示
        if (data.as == undefined || data.as == '') { // 判断面积是否输入，如果没有输入先提示，再清空子题的答案
          Toast('请先输入面积')
          this.$set(lists, 'as', '')
        } else if (lists.num != undefined && lists.num != '') { // 如果要智能提示并且面积也输入了
          var urls = this.accountUrl + '/riskevalAI/checkEquipment?site_category_id=' + this.timuData.siteCategoryId + '&question_id=' + item.id + '&area=' + data.as + '&equipment_name=' + lists.answer_content + '&number=' + lists.num
          var that = this
          this.utils.GET(urls, function (res) {
            that.alertShow = !res.data
          })
        }
      }
      this.yijireg()
    },
    erjireg (data) {
      for (var i = 0; i < data.subList.length; i++) {
        var item = data.subList[i]
        if (data.que_type == 7 && (item.que_type == 1 || item.que_type == 5)) { // 输入框加单选
          if (item.show && item.userQuestionAnswerList.length == '0') {
            console.log(item.que_content, item, '子题未答')
            return false
          }
        } else if (item.show == false) {
          return true
        } else if (item.userQuestionAnswerList.length == '0') {
          console.log(item.que_content, item, '子题未答')
          return false
        }
        if (item.que_type == 6 && this.duoxuanreg(item) === false) { // 多选加输入框
          return false
        }
      }
    },
    yijireg () {
      for (var i = 0; i < this.timuData.siteQuestionList.length; i++) {
        var item = this.timuData.siteQuestionList[i]
        if (item.userQuestionAnswerList.length == 0) {
          this.$set(item, 'weida', true)
          console.log(item, '一级题目:' + item.que_content + ',没做')
        } else {
          this.$set(item, 'weida', false)
        }
        if (item.que_type == 6) { // 多选加输入框
          this.$set(item, 'weida', this.duoxuanreg(item) === false)
        } else if (item.que_type == 7) { // 输入框加条件加子题
          if (item.userQuestionAnswerList.length == 0) {
            this.$set(item, 'weida', true)
          } else {
            console.log(this.erjireg(item), 333)
            this.$set(item, 'weida', this.erjireg(item) === false)
          }
        } else if (item.que_type == 8) { // 单选加输入框
          if (item.userQuestionAnswerList.answer == '有' && (item.userQuestionAnswerList.number == '' || item.userQuestionAnswerList.number == undefined)) {
            console.log(item, '一级题目:' + item.que_content + ',没做')
            this.$set(item, 'weida', true)
          }
        } else if (item.que_type == 10) { // 输入框答案加子题
          if (item.userQuestionAnswerList.length == 0) {
            this.$set(item, 'weida', true)
          } else {
            this.$set(item, 'weida', this.erjireg(item) === false)
          }
        } else if (item.que_type == 11) { // 多选加输入框答案加子题
          var num1 = 0 // 记录有几个子题要答
          var num2 = 0 // 记录子题是否都已答题
          for (var j = 0; j < item.siteQuestionAnswerList.length; j++) {
            var list = item.siteQuestionAnswerList[j]
            if (list.as !== undefined && list.as) {
              list.subList.forEach((li, k) => {
                this.$set(li, 'show', 'true')
              })
              num1++
              this.erjireg(list) === false ? '' : num2++
            }
          }
          if (item.userQuestionAnswerList.length == 0) {
            this.$set(item, 'weida', true)
          } else {
            if (item.userQuestionAnswerList[0].answer == '都没有') {
              this.$set(item, 'weida', false)
            } else {
              this.$set(item, 'weida', num1 !== num2 || this.duoxuanreg(item) === false)
            }
          }
        }
      }
      var num = 0
      for (var i = 0; i < this.timuData.siteQuestionList.length; i++) {
        var item = this.timuData.siteQuestionList[i]
        item.weida ? '' : num = num + 1
      }
      this.disabled = num !== this.timuData.siteQuestionList.length
    },
    duoxuanreg (item) { // 验证多选加输入框是否已填
      if (item.userQuestionAnswerList.length == 0) {
        console.log('题目:' + item + ',没做')
        return false
      }
      for (var j = 0; j < item.userQuestionAnswerList.length; j++) {
        var list = item.userQuestionAnswerList[j]
        if (list.answer !== '都没有' && (list.number == undefined || list.number == '')) {
          console.log(list, '题目:' + item.que_content + ',没做')
          return false
        }
      }
    },
    gettimu () { // 获取场所题目
      var that = this
      this.utils.GET(this.accountUrl + '/riskevalNew/getQuestionBySite', function (res) {
        if (res.data.length > 0) {
          that.timuData = res.data[0]
        } else {
          that.$router.replace({path: '/fxcp_anquan', query: {phoneNumber: that.$route.query.phoneNumber}})
        }
      })
    },
    submit1 () {
      this.isclick = true
      this.yijireg()
      var index = this.timuData.siteQuestionList.findIndex((v, i) => { return v.weida == true })
      if (index == 0) {
        window.scrollTo(0, 0)
      } else {
        var obj = document.getElementById(index)
        window.scrollTo(0, obj.offsetTop - 200)
      }
    },
    submit () {
      axios({ //  上传答题答案
        method: 'post',
        url: this.accountUrl + '/riskevalNew/commitSiteQuestion',
        data: this.timuData,
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          'Cache-control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 0,
          'zxzxkey': '',
          'phone': this.$route.query.phoneNumber
        },
        dataType: 'json'
      }).then(res => {
        location.reload()
      })
    }
  },
  watch: {},
  computed: {}
}
</script>

<style scoped>
	input::-webkit-input-placeholder { /* WebKit browsers */
    color:#ccc;
  }
  /*.mainHeader {*/
  /*  position: fixed;*/
  /*  top: 0px;*/
  /*  height: 55px;*/
  /*  width: 100%;*/
  /*  z-index: 500;*/
  /*}*/
  .wrapper {
    background:#F9F9F9;
    padding-bottom:84px;
    color:#000000;
    font-family:Microsoft YaHei;
    font-size:16px;
    line-height:36px;
  }
  .title1{
    line-height: 54px;
    background: #FFFFFF;
    padding: 0 0 0 15px;
    font-weight: bold;
  }
  .timu{
    margin: 10px 0 0 0;
    padding: 20px 15px;
    background: #FFFFFF;
    position: relative;
  }
  .inputs{
    width:100%;
    height:50px;
    background: white;
    border:0.5px solid #DADADA;
    padding: 0 0 0 20px;
    /*margin-bottom: 20px;*/
  }
  .title{
    font-weight:bold;
  }
  .beizhu{
    font-weight:400;
    color:#808080;
    font-size:12px;
  }
  .bj{
    position:fixed;
    width:100vw;
    height: 100vh;
    background:rgba(0,0,0,0.5);
    z-index: 10000;
  }
  .box{
    width:88%;
    height:266px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    background: #FFFFFF;
    text-align: center;
  }
  .weitian {
    /*background: #fff7f7;*/
    border: 1px solid #fecdcd;
  }
  .weida {
    position: absolute;
    bottom: 1px;
    right: 1px;
    padding: 3px 20px 3px 45px;
    color: #c41335;
    font-size: 13px;
    line-height: 20px;
    background: url(../assets/gantanhao.png) no-repeat;
    background-size: 15px;
    background-position: 21px 5px;
    background-color: #fff7f7;
  }
</style>
<style type="text/css">
  .el-radio__inner,.el-checkbox__inner{
    height: 20px !important;
    width: 20px !important;
    border-radius: 10px !important;
  }
  .el-checkbox__inner::after {
    height: 9px !important;
    left: 6px !important;
    top: 3px !important;
    width: 4px !important;
  }
  .el-radio__input.is-checked .el-radio__inner,.el-checkbox__input.is-checked .el-checkbox__inner{
    background-color: #C41335 !important;
    border-color: #C41335 !important;
  }
  .el-checkbox__input.is-checked+.el-checkbox__label,.el-radio__input.is-checked+.el-radio__label {
    color: #C41335 !important;
  }
</style>



// WEBPACK FOOTER //
// src/view/fxcp_changsuo.vue